{
  "first_session": {
    "intro": "You run a golfer's life. The game plays the golf. Let's start with one decision.",
    "q_familiarity": "How well do you know golf?",
    "familiarity_new": "New to it",
    "familiarity_some": "I follow it a bit",
    "familiarity_golfer": "I play",
    "familiarity_stats": "I play and love the numbers",
    "q_motivation": "What sounds most like you?",
    "motivation_improve": "Getting a handicap down",
    "motivation_career": "A career: tours, rankings, titles",
    "motivation_life": "Running a whole golf life",
    "motivation_society": "Golf with my society and friends",
    "motivation_knowledge": "Knowing courses and why scores happen",
    "skip": "Skip",
    "edit_later": "You can change these any time in Settings.",
    "decision_prompt": "{golferName} plays Saturday's medal at {courseName} in two days. How should they spend them?",
    "expect_prompt": "What do you think this will do?",
    "expect_better": "Better",
    "expect_same": "About the same",
    "expect_unsure": "Not sure",
    "sim_label": "One simulated round",
    "expected_back": "You expected: {expectation}.",
    "one_round_caveat": "One round has a lot of luck in it. The figures below are what this choice is worth on average for a golfer like {golferName}.",
    "worth_line": "On average, {choiceName} is worth about {strokes, plural, one {# shot} other {# shots}} a round for a golfer like {golferName}.",
    "worth_and_today_line": "On average, {choiceName} is worth about {strokes, plural, one {# shot} other {# shots}} a round for a golfer like {golferName}, and today it was worth {today, plural, one {# shot} other {# shots}}.",
    "no_clear_worth": "For a golfer like {golferName}, the choices here are too close to call from one round.",
    "next_chapter": "Now make your own golfer. Their first event is already on the calendar, and nothing starts until you're ready.",
    "q_focus": "What should {golferName}'s first season be about?",
    "focus_later": "Decide later",
    "first_up": "First up for {golferName}: a practice round, whenever you're ready.",
    "first_decision": "The one decision before it: how {golferName} gets ready.",
    "to_today": "Go to Today"
  },
  "today": {
    "since_heading": "Since you last looked",
    "since_report": "{golferName} finished {finish} in the {eventName}.",
    "since_report_neutral": "{golferName}'s round in the {eventName} is complete.",
    "since_energy_up": "{golferName}'s energy is back to {band}.",
    "since_energy_down": "{golferName}'s energy is down to {band}.",
    "since_form": "{golferName}'s form is now {band}.",
    "since_society": "{societyName}'s week is complete. {golferName} finished {place}.",
    "since_lapsed": "{count, plural, one {# moment} other {# moments}} passed with nothing changed.",
    "since_next": "Next: the {eventName} at {courseName}, {day}.",
    "primary_challenge": "Make three choices for {friendName}'s challenge",
    "primary_prepare": "Get {golferName} ready for the {eventName}",
    "primary_moment": "Answer: {momentTitle}",
    "primary_plan": "Approve today's plan",
    "primary_none": "Nothing needs you today. {golferName}'s next event is the {eventName} on {day}.",
    "ending_saved": "Plan saved. {golferName} plays the {eventName} on {day}.",
    "ending_done": "That's today's golf sorted."
  },
  "prepare": {
    "study": "Study the course",
    "study_cost": "{hours, plural, one {# golf hour} other {# golf hours}}. Better choices on holes {golferName} doesn't know yet.",
    "rest": "Rest and recover",
    "rest_cost": "No golf hours. {golferName} starts with more energy; no practice gained.",
    "train_approach": "Train approach play",
    "train_approach_cost": "{hours, plural, one {# golf hour} other {# golf hours}}. Approach skill rises slowly; {golferName} starts a little more tired.",
    "practice_round": "Play a practice round",
    "practice_round_cost": "{coins, plural, one {# Coin} other {# Coins}} and {hours, plural, one {# golf hour} other {# golf hours}}. Walk it and learn its holes.",
    "worth_known": "For a golfer like {golferName}: about {strokes, plural, one {# shot} other {# shots}} a round on average.",
    "worth_unknown": "Its effect for a golfer like {golferName} isn't measured yet."
  },
  "result": {
    "report_ready_attributed": "{golferName}'s report is ready. They finished {finish} at {courseName}. {finding}",
    "report_ready_neutral": "The round is complete. See the scorecard and what shaped the result.",
    "you_expected": "You expected: {expectation}. Here's what the report found.",
    "sg_first_time": "Strokes gained compares each shot with what a typical golfer of the same level would take from the same spot. Plus is better than typical.",
    "uncertain": "What we can't tell from one round: whether the same choice would help again tomorrow. Over a season, the averages above are the better guide."
  },
  "society": {
    "week_title": "The {societyName} Week",
    "week_done": "{societyName}'s week is complete. {winnerName} won with {score}.",
    "week_done_tied": "{societyName}'s week is complete. {winnerNames} tied on {score}.",
    "week_team": "Your team finished {place}.",
    "week_best_vs_average": "Best against their own average: {golferName}, {shots, plural, one {# shot} other {# shots}} better than usual.",
    "week_played": "{count, plural, one {# member played} other {# members played}} for the society this week.",
    "week_benchmark": "AI benchmark: {score}",
    "recap_cta": "Read the short recap",
    "mastery_line": "Before {day}, {golferName} chose {choiceName}. On average that's worth about {strokes, plural, one {# shot} other {# shots}} a round for a golfer like {golferName}.",
    "mastery_unclear": "What {golferName} did before {day} is too close to call from one round.",
    "plan_saved": "Plan saved. {golferName} plays the {eventName} at {courseName} on {day}. You'll see the society's table on Monday."
  },
  "challenge": {
    "invite": "{friendName} invited you to a ready-golfer challenge at {courseName}. Make three preparation choices.",
    "pick_golfer": "Pick a ready-made golfer",
    "choices_left": "{count, plural, one {# choice left} other {# choices left}}",
    "after_own_golfer": "Make my own golfer",
    "after_join_society": "Join {societyName}",
    "after_not_now": "Not now",
    "kept_for_you": "Your golfer and this report stay with you if you make an account in the next {days} days."
  },
  "return": {
    "opening": "Welcome back. {golferName} played {eventCount, plural, =0 {no events} one {# event} other {# events}} while you were away. Here's what changed. Your plans and history are all kept.",
    "autoplay_line": "Your caddie and coach ran the week, as you asked.",
    "decisions_heading": "Worth a look now"
  },
  "notify": {
    "settings_heading": "What would you like to hear about?",
    "settings_explain": "We only send something when there's news about your golfer, your society or a friend. You choose which, and when.",
    "cat_report": "Round reports for your golfers",
    "cat_challenge": "Challenges from friends",
    "cat_society": "Your society's weekly result",
    "cat_followed": "Events you entered or follow",
    "cat_milestone": "Milestones you chose",
    "cat_digest": "A weekly digest",
    "digest_time": "Send my digest on {day} at {time}",
    "lock_details": "Show details on the lock screen",
    "lock_details_note": "Off: the lock screen just says a report is ready. Scores stay inside the app.",
    "turn_on": "Turn on notifications",
    "not_now": "Not now",
    "push_report_private": "{golferName}'s round report is ready.",
    "push_report_detail": "{golferName}'s round report is ready: {finish} at {courseName}. View the scorecard.",
    "push_challenge": "{friendName} sent you a challenge. Make three preparation choices for {courseName}.",
    "push_society_private": "{societyName}'s weekly result is ready.",
    "push_society_detail": "{societyName}'s weekly result is ready. See your team's finish and the recap.",
    "push_followed_private": "The {eventName} has finished.",
    "push_followed_detail": "The {eventName} has finished. {golferName} was {finish}.",
    "push_milestone_private": "A milestone you chose has been reached.",
    "push_milestone_detail": "{golferName} reached {milestone}.",
    "push_digest": "Your Week in Golf is ready."
  },
  "share": {
    "label": "{gameName}, a golf-life simulator. Rounds are simulated.",
    "society_week": "{golferName} won the {societyName} Week with {score}.",
    "society_week_safe": "{golferName} played in the {societyName} Week.",
    "event_finish": "{golferName} finished {finish} in the {eventName} at {courseName}.",
    "event_finish_safe": "{golferName} played the {eventName} at {courseName}.",
    "milestone": "{golferName} reached {milestone}.",
    "cta_challenge": "Take on {golferName}: pick a golfer, make three choices",
    "challenge_friend": "{golferName} challenges you: get ready for {eventName}.",
    "challenge_friend_ahead": "{aheadName} finished {strokes, plural, one {# stroke} other {# strokes}} ahead of {otherName}.",
    "challenge_friend_level": "{golferName} and {otherName} finished level.",
    "cta_society": "See {societyName}"
  },
  "ai": {
    "row": "AI",
    "profile": "AI golfer",
    "spoken": "AI golfer"
  },
  "settings": {
    "interests_heading": "Your interests",
    "explain_style": "How should reports explain things?",
    "style_short": "Short and plain",
    "style_caddie": "In my caddie's words",
    "style_numbers": "With the numbers",
    "reset": "Reset to the defaults",
    "reset_done": "Back to the defaults. Nothing about your golfer has changed."
  },
  "exits": {
    "keep_bag": "Keep my current bag",
    "keep_plan": "Keep my current plan",
    "leave_offer": "Leave this offer",
    "pause_updates": "Pause updates",
    "paused": "Updates from {sourceName} are paused. You can turn them back on in Settings.",
    "left": "Offer left. Nothing about your golfer has changed."
  },
  "voice": {
    "label_record": "Record",
    "label_advice": "Advice from {characterName}",
    "label_service": "Service from {businessName}",
    "label_commercial": "Offer from {businessName}",
    "label_run_by_game": "Run by the game",
    "label_ai_customers": "Some customers are played by the game.",
    "society_fixture": "{societyName}'s next fixture is at {courseName} on {day}.",
    "coach_block": "You chose {focus} for this block. {summary} Keep this plan, change the focus, or look at rest?",
    "caddie_brief": "{caddieName}'s notes for {courseName} are ready. They cover the course, the forecast and {golferName}'s energy.",
    "fitting_compare": "Compare {clubA} and {clubB} for {golferName}. Based on {basis}. It costs {cost}. The difference may be small.",
    "maker_research": "{businessName}'s research on {topic} is complete. The new model is on sale from {day}.",
    "owner_work_done": "{workName} is complete. {changeLine}",
    "owner_review_heading": "Your week at {clubName}",
    "owner_review_intro": "Here is what changed this week. Each item has one choice, and you can leave them all as they are.",
    "setback": "{resultLine} The report shows what came from the plan, from the weather and from luck.",
    "coalesced": "{count, plural, one {# more update} other {# more updates}} about this, in one place."
  },
  "offer": {
    "heading": "More practice for {golferName}",
    "body": "{tierName} membership gives {golferName} more practice each day and better facilities. It costs {price} a month.",
    "charter": "Everyone can build a golf career. Membership buys extra practice and better facilities, helping your golfer develop faster. Results still depend on your golfer, your decisions and the simulation; purchases do not guarantee wins.",
    "cap_line": "All that a membership adds stays inside one limit. With the same choices, a member's golfer gets to any level at most {capShare} sooner.",
    "compare": "Compare memberships"
  },
  "interests": {
    "title": "Your interests",
    "note": "These change how things are explained and what Today shows first.",
    "familiarity": "How well you know golf",
    "motivation": "What sounds most like you",
    "focus": "First season focus",
    "not_set": "Not set",
    "reset": "Reset",
    "reset_done": "Your interests are back to the defaults.",
    "settings_link": "Your interests",
    "back": "Settings, back"
  }
}
